import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Typography, FormControlLabel, FormHelperText, Checkbox, Dialog } from '@material-ui/core';
import { useFormik } from 'formik';
import Input from 'components/Input';
import Select from 'components/Select';
import Button from 'components/Button';
import WarningMessage from 'components/WarningMessage';

import { changeAccount } from '../../store/thunk';

import { validations, modalValidations } from './validations';

export default function ChangeAccount() {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { establishments } = useSelector(state => state.login);
  const { isLoading } = useSelector(state => state.advancedConfigs);

  const { label } = establishments?.find(establishment => +establishment?.establishmentId == +establishmentId) || {};

  const [isModalOpen, setIsModalOpen] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: validations,
    initialValues: {
      newClientSl: '0',
      name: '',
      phone: '',
      email: ''
    },
    onSubmit: () => setIsModalOpen(true)
  });

  const isNewClientSl = +formik.values.newClientSl == 1;

  const modalFormik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: modalValidations,
    initialValues: {
      reason: '',
      password: '',
      passwordConfirm: '',
      actionConsent: false
    },
    onSubmit: values => {
      const params = {
        reason: values?.reason,
        userPassword: values?.password,
        name: formik.values.name,
        phone: formik.values.phone,
        email: formik.values.email,
        newClientSl: +formik.values.newClientSl
      }

      dispatch(changeAccount(userId, establishmentId, params)).then(() => {
        formik.resetForm();
        modalFormik.resetForm();
        setIsModalOpen(false);
      });
    }
  });

  return(
    <Grid container>
      {isModalOpen && (
        <Dialog
          id='change-account-advanced-config-modal'
          scroll='body'
          maxWidth='lg'
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <Grid container spacing={2} style={{ padding: 30 }}>
            <Grid item xs={12}>
              <WarningMessage
                justifyContent="flex-start"
                message="Essa ação não poderá ser desfeita!"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>
                {isNewClientSl ? (
                  <>
                    Confirmo que <b>{formik.values.name}</b>, telefone <b>{formik.values.phone}</b> e endereço de e-mail <b>{formik.values.email}</b> é o novo titular deste estabelecimento <b>{label}</b>.
                  </>
                ) : (
                  <>
                    Confirmo que o endereço de e-mail <b>{formik.values.email}</b> é o novo titular deste estabelecimento <b>{label}</b>.
                  </>
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <form onSubmit={modalFormik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12} md={8}>
                        <Input
                          name="reason"
                          type="text"
                          label="Motivo"
                          value={modalFormik.values.reason}
                          error={modalFormik.errors.reason}
                          helperText={modalFormik.errors.reason}
                          onChange={modalFormik.handleChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Input
                      name="password"
                      type="password"
                      label="Informe sua senha"
                      value={modalFormik.values.password}
                      error={modalFormik.errors.password}
                      helperText={modalFormik.errors.password}
                      onChange={modalFormik.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Input
                      name="passwordConfirm"
                      type="password"
                      label="Repita sua senha"
                      value={modalFormik.values.passwordConfirm}
                      error={modalFormik.errors.passwordConfirm}
                      helperText={modalFormik.errors.passwordConfirm}
                      onChange={modalFormik.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      labelPlacement='end'
                      label={
                        <Typography color='primary'>
                          Estou ciente que esta ação não poderá ser desfeita
                        </Typography>
                      }
                      control={
                        <Checkbox
                          checked={modalFormik.values.actionConsent}
                          onChange={event => modalFormik.setFieldValue('actionConsent', event.target.checked)}
                        />
                      }
                    />
                    {!!modalFormik.errors.actionConsent && (
                      <FormHelperText error>
                        {modalFormik.errors.actionConsent}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <Button
                      type="button"
                      variant="outlined"
                      color="tertiary"
                      loading={isLoading}
                      onClick={() => setIsModalOpen(false)}
                    >
                      Voltar
                    </Button>
                    <Button
                      disabled={!modalFormik.values.reason || !modalFormik.values.password || !modalFormik.values.passwordConfirm || !modalFormik.values.actionConsent}
                      type="submit"
                      color="success"
                      loading={isLoading}
                    >
                      Finalizar
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Dialog>
      )}
      <Grid xs={12}>
        <Typography variant='subtitle1'>
          <b>A troca de titularidade colocará o novo usuário como responsável e gerente deste estabelecimento e o atual usuário não terá mais acesso ao mesmo! Essa ação não pode ser desfeita!</b>
        </Typography>
      </Grid>
      <Grid xs={12}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{ marginTop: 30 }}>
                Preencha os campos do novo titular
              </Typography>
            </Grid>
            <Grid item xs={12} md={5}>
              <Select
                name="newClientSl"
                label="Cliente SL"
                options={[
                  { value: '0', label: 'Usuário Jump Existente' },
                  { value: '1', label: 'Novo Usuário Jump' }
                ]}
                value={formik.values.newClientSl}
                error={formik.errors.newClientSl}
                helperText={formik.errors.newClientSl}
                onChange={event => {
                  formik.setFieldValue('newClientSl', event.target.value);

                  formik.setErrors({
                    ...formik.errors,
                    name: undefined,
                    phone: undefined,
                    newClientSl: undefined
                  });
                }}
              />
            </Grid>
          </Grid>
          {(formik.values.newClientSl == 1) && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={7}>
                <Input
                  name="name"
                  type="text"
                  label="Nome completo"
                  value={formik.values.name}
                  error={formik.errors.name}
                  helperText={formik.errors.name}
                  onChange={formik.handleChange}
                />
              </Grid>
            </Grid>
          )}
          {(formik.values.newClientSl == 1) && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Input
                  name="phone"
                  type="phone"
                  label="Telefone"
                  value={formik.values.phone}
                  error={formik.errors.phone}
                  helperText={formik.errors.phone}
                  onChange={formik.handleChange}
                />
              </Grid>
            </Grid>
          )}
          <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
              <Input
                name="email"
                type="email"
                label="E-mail"
                value={formik.values.email}
                error={formik.errors.email}
                helperText={formik.errors.email}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                type="submit"
                color="success"
              >
                Avançar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
}